// src/routes/SuperAdminRoutes.js
import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from '../components/SuperAdmin/AuthContext';
import SuperAdminLogin from '../components/SuperAdmin/SuperAdminLogin';
import Dashboard from '../components/SuperAdmin/Dashboard';
import ProjectDashboard from '../components/SuperAdmin/ProjectDashboard';
import DeveloperDashboard from '../components/SuperAdmin/DeveloperDashboard';
import BrandDetails from '../components/SuperAdmin/BrandDetails';
import SuperAdminHeader from '../components/SuperAdmin/SuperAdminHeader';

// Layout wrapper for protected pages
function ProtectedLayout() {
    const { user, logout, loading } = useAuth();
    if (loading) return <div>Loading...</div>;

    const userName = user?.displayName || user?.email || 'Admin';
    const handleLogout = logout;

    return (
        <div className="min-h-screen bg-gray-100">
            <SuperAdminHeader userName={userName} handleLogout={handleLogout} />
            <main className="p-6">
                {/* Render matched child route here */}
                <Outlet />
            </main>
        </div>
    );
}

// Main routing component
export default function SuperAdminRoutes() {
    return (
        <AuthProvider>
            <Routes>
                {/* Public login route */}
                <Route path="/login" element={<SuperAdminLogin />} />

                {/* Protected admin routes under layout */}
                <Route element={<ProtectedLayout />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/project-dashboard" element={<ProjectDashboard />} />
                    <Route path="/developer-dashboard" element={<DeveloperDashboard />} />
                    <Route path="/brand-details" element={<BrandDetails />} />
                </Route>

                {/* Fallback redirect */}
                <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
        </AuthProvider>
    );
}
